import { render } from "./IconWarningCircle.vue?vue&type=template&id=08ad4bd1"
import script from "./IconWarningCircle.vue?vue&type=script&lang=js"
export * from "./IconWarningCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__